import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "hidden",
    },
    body: {
        display: "flex",
        flex: "1 1 auto",
        height: 0,
        flexDirection: "row",
        overflow: "hidden",
        minHeight: 0,
    },
    leftPanel: {
        flex: "0 0 375px",
        width: 375,
        minWidth: 375,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "white",
        borderRight: "1px solid #e0e0e0",
    },
    newComparisonBar: {
        flexShrink: 0,
        padding: theme.spacing(1),
        borderBottom: "1px solid #e0e0e0",
        display: "flex",
        justifyContent: "center",
    },
    rightPanel: {
        flex: "1 1 auto",
        minWidth: 0,
        height: "100%",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
    },
    heatmapPanel: {
        flex: "1 1 auto",
        minWidth: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: theme.spacing(1),
    },
    propsPanel: {
        flex: "0 0 350px",
        width: 350,
        minWidth: 350,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "white",
        borderLeft: "1px solid #e0e0e0",
    },
    propsPanelScroll: {
        flex: "1 1 auto",
        height: 0,
        overflowY: "auto",
        padding: "24px",
    },
    propsSectionLabel: {
        display: "flex",
        alignItems: "center",
        marginTop: 14,
        marginBottom: 10,
        marginLeft: -16,
        marginRight: -16,
        paddingLeft: 8,
        paddingRight: 8,
        color: "#1982DD",
        fontWeight: 600,
        "&::after": {
            content: '""',
            flex: 1,
            height: 1,
            backgroundColor: "#1982DD",
            marginLeft: 8,
        },
    },
    propsCellRow: {
        width: "100%",
        textAlign: "center",
        marginBottom: 2,
    },
    propsCellName: {
        fontWeight: 600,
        color: "#222",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    propsCellStat: {
        color: "#666",
        fontSize: "0.85rem",
    },
    propsCellDivider: {
        color: "#aaa",
        fontSize: "1.1rem",
        lineHeight: 1,
        marginTop: 8,
        marginBottom: 8,
    },
    propsNoCell: {
        color: "#aaa",
        fontStyle: "italic",
        textAlign: "center",
        paddingTop: 8,
    },
    propsPanelTop: {
        flexShrink: 0,
        padding: theme.spacing(1),
        textAlign: "center",
        borderBottom: "1px solid #e0e0e0",
        // Fixed height keeps layout stable when toggling between compare-button and cell-info.
        // name(20) + stat(18) + mb(2) = 40px × 2 rows + divider(18+16) = 114px + padding(16) = 130px
        height: 130,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    cellInfoBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    compareButtonOverlay: {
        position: "relative",
    },
    compareButton: {
        width: "100%",
        height: 80,
    },
    compareButtonData: {
        paddingTop: 12,
        paddingLeft: 4,
        color: "#555",
        fontSize: "0.85rem",
        textAlign: "center",
    },
    propsPanelBottom: {
        flexShrink: 0,
        padding: "8px",
        borderTop: "1px solid #e0e0e0",
    },
    paper: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        boxShadow: "0px 0px 2px 2px rgba(0,0,0,0.1)",
        overflow: "hidden",
    },
    panelHeader: {
        padding: "8px 12px",
        backgroundColor: "#f5f5f5",
        borderBottom: "1px solid #ddd",
        fontWeight: 600,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
    },
    tableScroll: {
        flex: "1 1 auto",
        height: 0,
        overflowY: "auto",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
    },
    th: {
        backgroundColor: "#F7F7F7",
        padding: "7px 10px",
        textAlign: "left",
        borderBottom: "2px solid #E6E6E6",
        fontWeight: 600,
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
    thCenter: {
        backgroundColor: "#F7F7F7",
        padding: "7px 10px",
        textAlign: "center",
        borderBottom: "2px solid #E6E6E6",
        fontWeight: 600,
        position: "sticky",
        top: 0,
        zIndex: 1,
        width: 80,
    },
    row: {
        cursor: "pointer",
        borderTop: "1px solid #e0e0e0",
        "&:nth-child(even)": { backgroundColor: "#f9f9f9" },
        "&:nth-child(odd)": { backgroundColor: "#ffffff" },
        "&:hover": { backgroundColor: "#e8f0fe" },
    },
    rowActive: {
        cursor: "pointer",
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#c9d9f7 !important",
    },
    td: {
        padding: "7px 10px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 0,
    },
    tdCenter: {
        padding: "7px 10px",
        textAlign: "center",
        width: 80,
    },
    // Heatmap
    heatmapWrapper: {
        flex: "1 1 auto",
        height: 0,
        overflow: "hidden",
        position: "relative",
    },
    heatmapScroll: {
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        padding: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    heatmapTooltip: {
        position: "fixed",
        pointerEvents: "none",
        background: "rgba(30,30,30,0.88)",
        color: "#fff",
        borderRadius: 4,
        padding: "5px 9px",
        fontSize: 12,
        lineHeight: 1.5,
        maxWidth: 260,
        zIndex: 2000,
        display: "none",
        whiteSpace: "pre-line",
        boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
        textAlign: "center",
    },
    emptyHint: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        color: "#888",
        fontStyle: "italic",
        padding: theme.spacing(2),
    },
    legend: {
        display: "flex",
        alignItems: "center",
        gap: 4,
        padding: "4px 8px",
        flexShrink: 0,
        borderTop: "1px solid #e0e0e0",
        color: "#555",
    },
    legendBar: {
        width: 160,
        height: 14,
        background: "linear-gradient(to right, hsl(120,75%,50%), hsl(60,75%,50%), hsl(0,75%,50%))",
        borderRadius: 3,
        border: "1px solid #ccc",
    },
}));
